'use client';

import ContactSection from '@/components/contacts/ContactSection';
import { useEntraAuth } from '@/components/hooks/useEntraAuth';
import customerServiceData from '@/content/contacts/en/customer-service-data.json';
import { spacing } from '@/theme/tokens';
import { Stack } from '@mui/material';
import { useScrollToHash } from '@/components/hooks/useScrollToHash';

export default function CustomerServiceClient() {
    const { isAuthenticated } = useEntraAuth();
    useScrollToHash();

    return (
        <Stack direction="column" gap={spacing[16]}>
            <ContactSection
                title={customerServiceData.locationContacts.title}
                locations={customerServiceData.locationContacts.locations}
                twoColumnsOnTabletForLocations
            />

            {isAuthenticated && (
                <ContactSection
                    title={customerServiceData.departmentContacts.title}
                    departments={customerServiceData.departmentContacts.departments}
                />
            )}
        </Stack>
    );
}
